import { FinalData } from "../types/types";

// Defensively decode JSON escape sequences that may have leaked through
// double-encoding on the backend (PHP storing JSON-as-string then re-encoding).
// Handles: \uXXXX, \/, \", \n, \r, \t, \\.
// Idempotent: a correctly-decoded string passes through unchanged (no escapes left).
const decodeJsonEscapes = (s: string): string => {
  return s.replace(
    /\\u([0-9a-fA-F]{4})|\\(["/\\nrt])/g,
    (_, hex, simple) => {
      if (hex) return String.fromCharCode(parseInt(hex, 16));
      switch (simple) {
        case "n": return "\n";
        case "r": return "\r";
        case "t": return "\t";
        case '"': return '"';
        case "/": return "/";
        case "\\": return "\\";
        default: return simple;
      }
    }
  );
};

const deepDecodeUnicode = (obj: any): any => {
  if (typeof obj === "string") return decodeJsonEscapes(obj);
  if (Array.isArray(obj)) return obj.map(deepDecodeUnicode);
  if (obj && typeof obj === "object") {
    const out: any = {};
    for (const k in obj) out[k] = deepDecodeUnicode(obj[k]);
    return out;
  }
  return obj;
};

const getFolder = (folderId: string) => {
  return new Promise((resolve, reject) => {
    var formData = new FormData();
    formData.append("folderId", folderId);

    fetch("https://app.windtransfer.net/ajax/get-folder.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        resolve(deepDecodeUnicode(result));
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const openFolder = (folderId: string) => {
  return new Promise((resolve, reject) => {
    var formData = new FormData();
    formData.append("folderId", folderId);

    fetch("https://app.windtransfer.net/ajax/open-folder.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        resolve(deepDecodeUnicode(result));
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const updateFolder = (folderId: string, serverData: Array<FinalData>) => {
  return new Promise((resolve, reject) => {
    var formData = new FormData();
    console.log(serverData);
    
    formData.append("ID", folderId);
    formData.append("myData", encodeURIComponent(JSON.stringify(serverData)));

    fetch("https://app.windtransfer.net/ajax/upload.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export { getFolder, openFolder, updateFolder };
